/**
 * Two types of lists are handled here
 *
 * 1. Any element with a .list-header right before a .list-expand.
 *    Clicking the .list-header will close or open the .list-expand
 *
 * 2. Any element with a .expand-by-id class and a matching .expand-by-id-item element.
 *    They should both have the same .data-list-id attributes.
 *    The .expand-by-id-element should also have a data-closed and a data-open attribute
 *    with the correct text to swap based on state.
 *
 * Either list can be open by default by adding the .active class to the controlling item
 *
 */
e.lists = {

	by_id_items : {},

	init : function(){
		//handle basic lists with .list-header and .list-expand
		var $lists = $( '.list-header' );
		$lists.on( 'click', this._show_hide_next_list );
		$lists.not( '.active' ).each( function(){
			$( this ).next( '.list-expand' ).hide();
		} );


		//handle items with data-list-id attributes
		this.by_id_items = $( '.expand-by-id-item' );
		var $id_list = $( '.expand-by-id' );
		$id_list.on( 'click', this._show_hide_by_id_item );
		$id_list.not( '.active' ).each( function(){
			e.lists.by_id_items.filter( '[data-list-id="' + $( this ).data( 'list-id' ) + '"]' ).hide();
		} );
	},


	/**
	 * Show or hide a list based on the data-list-id attribute
	 * Take the list of items set in init() and filter based on
	 * a controlling element
	 *
	 * @param {jQuery} el
	 * @private
	 */
	_show_hide_by_id_item : function(){
		var el = $(this);
		var $list = e.lists.by_id_items.filter( '[data-list-id="' + el.data( 'list-id' ) + '"]' ).hide();

		e.lists._show_hide( el, $list, function( state ){
			el.text( el.data( state ) );
		});

	},


	/**
	 * Show or hide the next list with the class .list-expand
	 *
	 * @param {jQuery} el
	 * @private
	 */
	_show_hide_next_list : function(){
		var el = $(this);
		var $list = el.next( '.list-expand' );
		e.lists._show_hide( el, $list );
	},


	/**
	 * Show or hide a list based on item controlling it
	 *
	 * @param {jQuery} el - controlling item e.g clicked button or arrow
	 * @param {jQuery} $list - list to be shown or hidden
	 * @param {function} [fn] - function to call with the state when complete
	 * @private
	 */
	_show_hide : function( el, $list, fn ){
		var $state = '';
		if( el.hasClass( 'active' ) ){
			$list.hide();
			el.removeClass( 'active' );
			$state = 'closed';
		} else {
			$list.show();
			el.addClass( 'active' );
			$list.on( 'click', 'li', $list.hide );
			$state = 'open';
		}

		if( typeof( fn ) == 'function' ){
			fn( $state );
		}

	}
};
